import axios from 'axios';
import { auth } from '../config/firebase';
import { API_BASE } from '../config/apiBase';

const API_BASE_URL = API_BASE;

const backendClient = axios.create({
  baseURL: `${API_BASE_URL}/smartthings`,
  headers: {
    'Content-Type': 'application/json'
  }
});

backendClient.interceptors.request.use(
  async (config) => {
    try {
      const currentUser = auth.currentUser;
      if (currentUser) {
        const idToken = await currentUser.getIdToken(false);
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    } catch (error) {
      console.error('Failed to attach Firebase token', error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

backendClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Silently handle 401 errors - they're expected when not logged in
    // The calling code will handle the error appropriately
    if (error.response?.status === 401) {
      // Only log once to avoid spam
      if (!window.__smartthings_auth_warning_shown) {
        console.log('SmartThings backend requires authentication. Please log in to access subscriptions.');
        window.__smartthings_auth_warning_shown = true;
      }
    }
    return Promise.reject(error);
  }
);

export const getSubscriptions = async () => {
  try {
    const response = await backendClient.get('/subscriptions');
    return response.data?.data || [];
  } catch (error) {
    // Don't log for auth errors - already handled by interceptor
    if (error.response?.status !== 401) {
      console.error('Failed to get subscriptions:', error.message);
    }
    return []; // Return empty array on error
  }
};

export const createSubscription = async (payload) => {
  const response = await backendClient.post('/subscriptions', payload);
  return response.data?.data;
};

export const deleteSubscription = async (subscriptionId) => {
  await backendClient.delete(`/subscriptions/${subscriptionId}`);
  return true;
};

export default {
  getSubscriptions,
  createSubscription,
  deleteSubscription
};
